import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { TableActions } from "../../../components/tables/tableContext/TableContext";
import {
  fetchGetClientsNodes,
  fetchUndeliveredAwb,
  getAwbStatuses,
} from "../../../redux/api/expedition.api";
import TableWidget from "../../../components/tables/TableWidget";
import {
  getUndeliveredAwbTableData,
  undeliveredAwbTableHeader,
} from "./tableConfig/undeliveredAwbTableConfig";
import UndeliveredAwbTableActionButtons from "./components/TableActionButtonComponent/UndeliveredAwbTableActionButtons";
import { useEffect, useMemo } from "react";
import { clearWorkingRoutesNodes } from "../../../redux/reducer/expedition.reducer";
import ChangeWorkingPointModal from "./components/ChangeWorkingPointModal";
import ChangePickingDateModal from "./components/ChangePickingDateModal";

function UndeliveredAwb() {
  const dispatch = useAppDispatch();

  const {
    expedition: {
      undeliveredAwb: {
        data: { data: dataUndeliveredAwb, total: totalUndeliveredAwb },
        isLoading: isLoadingAwb,
      },
      workingRoutesNodes: {
        data: { data: clientsNodesData },
        isLoading: isLoadingNodes,
      },
      awbStatuses: { data: awbStatusesData, isLoading: isLoadingAwbStatus },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  useEffect(() => {
    dispatch(
      fetchGetClientsNodes({
        page: 1,
        perPage: 50,
      }),
    );

    dispatch(getAwbStatuses());

    return () => {
      dispatch(clearWorkingRoutesNodes());
    };
  }, [dispatch]);

  const handleAwbTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch &&
      action.tableFilter
    ) {
      dispatch(
        fetchUndeliveredAwb({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          pctlivrare: action.tableSearch.pctlivrare,
          nodDestinatie: action.tableFilter.nodDestinatie,
          doc_trans: action.tableSearch.doc_trans,
          status: action.tableFilter.status,
        }),
      );
    }
  };

  const undeliveredAwbTableHeaderNew = useMemo(
    () =>
      undeliveredAwbTableHeader.map((item) => {
        if (!isLoadingNodes && item.value === "nodDestinatie") {
          const nodesDropdown = clientsNodesData?.map(
            ({ nodNume, id_nod }) => ({
              label: nodNume,
              value: id_nod,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: 0 }, ...nodesDropdown],
            ...item,
          };
        }
        if (!isLoadingAwbStatus && item.value === "status") {
          const awbStatusesDropdown = awbStatusesData?.map(
            ({ denumire, valoare }) => ({
              label: denumire,
              value: valoare,
            }),
          );
          return {
            withFilter: [
              { label: "Toate", value: "all" },
              ...awbStatusesDropdown,
            ],
            ...item,
          };
        }
        return item;
      }),
    [awbStatusesData, clientsNodesData, isLoadingAwbStatus, isLoadingNodes],
  );

  return (
    <>
      <ChangeWorkingPointModal />
      <ChangePickingDateModal />
      <TableWidget
        tableTitle="Comenzi nefinalizate"
        tableHeaderData={undeliveredAwbTableHeaderNew}
        tableItemsData={getUndeliveredAwbTableData(dataUndeliveredAwb)}
        totalItems={totalUndeliveredAwb}
        tableLoading={isLoadingAwb}
        handleTableActions={handleAwbTableActions}
        ActionButtonsComponent={UndeliveredAwbTableActionButtons}
        borderedRow
      />
    </>
  );
}

export default UndeliveredAwb;
